<div class="step-container main-content">
  <h3>
    Contract Details |
    <app-company-quoteid-header [quote]="quoteRequestState" [organisationName]="organizationName"></app-company-quoteid-header>
  </h3>
  <div class="contract-form" *ngIf="data">
    <jsonforms
      [readonly]="loading || isReadOnly"
      [data]="data"
      [schema]="schema"
      [uischema]="displaySchema"
      [renderers]="renderers"
      [ajv]="validationSettings"
      (dataChange)="setData($event)"
    >
    </jsonforms>

    <app-credit-check></app-credit-check>

    <div class="contract-generation">
      <div *ngIf="!contractGenerated">
        <h4>Generate Contract for Customer to Sign</h4>
        <app-contract-generation *ngIf="data?.contractType !== 'None'"
                                 [disabled]="isCreditCheckValidated() || !isFormValid || contractGenerated"
                                 [multipleAddressDisabled]="isUseDefaultAddressChecked"
                                 [contractData]="data"
                                 [schemaId]="schemaId"
                                 [quoteRequestId]="quoteRequestId"
                                 [isNewContract]="isNewContract"
                                 [customerType]="customerType"
                                 (contractGenerated)="contractGeneratedHandler($event)">
        </app-contract-generation>
      </div>

      <section *ngIf="contractGenerated" class="pdfUpload">
        <app-upload *ngIf="data?.contractType === 'PDF'"
                    (after-closed)="onCompleteUpload($event)"
                    [document-type]="'SignedContractDocument'"
                    [upload-description]="'Drag and drop your contract here'"
                    [multiple]="false"
                    [disabled]="isCreditCheckValidated() || isReadOnly"></app-upload>
        <section *ngIf="signedContractDocuments?.length > 0">
          <h4>{{ data?.contractType === 'DocuSign' ? 'Countersigned Contract' : 'PDF Contract' }}</h4>
          <ul class="file-list">
            <li *ngFor="let file of signedContractDocuments">
              <div class="delete-file">
                <a class="download-link" appDownloadLink [file]="file">{{ file.fileName }}</a>
                <app-delete-file [file]="file"
                                 [quoteRequestId]="quoteRequestId"
                                 (after-delete)="onDeleteUpload($event)"
                                 *ngIf="quoteRequestState.status !== 'PendingEnrollment'"></app-delete-file>
              </div>
            </li>
          </ul>
        </section>
        <span class="contract-error-message" *ngIf="signedContractDocuments?.length === 0">Please {{data?.contractType === 'DocuSign' ? 'review the contract sent to your email address' : 'upload a signed contract'}} </span>
      </section>
    </div>
  </div>
</div>

<app-wizard-step-nav-buttons
  (backClicked)="back()"
  (nextClicked)="next()"
  [hideNext]="data?.contractType !== 'PDF' && data?.contractType !== 'None'"
>
  <span nextButton>
    <button
      mat-flat-button
      color="accent"
      [disabled]="(contractGenerated && data?.contractType !== 'None') || loading || isReadOnly"
      (click)="save()"
    >
      <i class="fa fa-save" aria-hidden="true"></i> Save <i *ngIf="loading" class="ml-2 fas fa-spinner fa-spin"></i>
    </button>
    <button
      *ngIf="((data?.contractType === 'PDF' && contractGenerated) || data?.contractType === 'None') && !isReadOnly"
      id="nextBtn"
      mat-flat-button
      color="accent"
      type="button"
      (click)="submitQuoteRequest()"
      [disabled]="isCreditCheckQuote && !successfulCreditCheck"
    >
      <i class="fa fa-paper-plane" aria-hidden="true"></i>
      Submit Signed Contract
    </button>
  </span>
</app-wizard-step-nav-buttons>
